export const Config = {
  CODEMASH: {
    PROJECT_ID: process.env.REACT_APP_CODEMASH_PROJECT_ID,
    SECRET_KEY: process.env.REACT_APP_CODEMASH_SECRET_KEY,
    FILE_ACCOUNT_ID: process.env.REACT_APP_CODEMASH_FILE_ID,
    DB_STORAGE_ID: process.env.REACT_APP_CODEMASH_DB_STORAGE_ID,
  },
  SHOW_LOGS: true,
  DEFAULTS: {
    LANGUAGE: 'en',
    PAGE_SIZE: 20,
    TAXONOMY_PAGE_SIZE: 20,
  },
  LANGUAGES: { LT: 'lt', EN: 'en', RU: 'ru' },
  AVAILABLE_LANGUAGES: ['lt', 'en', 'ru'],
  ORDERED_AVAILABLE_LANGUAGES: ['en', 'lt', 'ru'],
  DATA: {
    LOADING_STATUS: {
      NOT_LOADING: 0,
      INITIAL_LOAD: 1,
      PAGING_LOAD: 2,
    },
    COLLECTIONS: {
      MENU: 'menu',
      TABLES: 'tables',
      ORDERS: 'orders',
      RATINGS: 'client-reviews',
      PAYMENTS: 'order-payments-v2',
      RESTAURANTS: 'restaurants',
      DELIVERY_SETTINGS: 'delivery-settings',
      PRODUCT_VARIATIONS: 'product-variations',
    },
    TAXONOMIES: {},
    AGGREGATES: {
      GET_TABLE: '309c4e75-1d04-4efc-b74a-c84cb82afd6f',
      GET_TABLE_V2: 'c5a68d02-75fd-46b3-857a-75b2c66b7be7',
      GET_TABLE_ORDER: '3c8ca8bc-5dc0-47e6-8201-3874c7034e1a',
      GET_TABLE_USER_ORDERS: '2f999434-73ce-45c9-a75e-cf5397afe059',
      GET_PAYMENT: 'd3cb6090-10e2-44be-8466-868e96fbd0e8',
      GET_PAYMENT_BY_EXTERNAL: 'ba7e4466-ad64-4e8c-84bf-0cd711bf74b7',
      GET_DINE_IN_MENU_PRODUCTS: 'e9f99c48-c545-4a38-bac8-28ad1623a3d0',
      GET_DINE_IN_MENU_PRODUCTS_OPTIMIZED: 'afa4ae1c-b8c1-458c-ae5d-baa4be617c35',
      GET_PRODUCTS_VARIATIONS: '21267e67-8d09-436b-8d54-7cbf8b627166',
      GET_COMPANY_RESTAURANTS_BY_SLUG_V2: '9d9c17e3-66b6-4e8d-9d2c-2c7c0f107e09',
      GET_VARIATION_JOINS: '62f37ea9-8dda-4350-8cd6-f1844ae77a16',
    },
    FUNCTIONS: {
      INITIATE_PAYMENT: '6afe8093-744d-49a8-a51c-620c762278b4',
      CHARGE_AUTHORIZED_PAYMENT: '4674920c-ba99-43e2-9d5a-196f4a2fe89f',
      GET_INVOICE: '4047f23c-ebf2-4eb4-809f-65d29412caf9',
    },
  },
  CACHE_KEYS: {
    CART: '@Waitless-Cart',
    CART_DELIVERY: '@Waitless-Cart-Delivery-',
    DEFAULT_DELIVERY_TYPE: '@Waitless-Default-Delivery-Type',
    SELECTED_APP_LANGUAGE: '@Waitless-App-Lang',
  },
};

export const defaultColors = {
  primary: '#181818',
};
